import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FDBodyText, FDIcon, FDStack,
} from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import { dataAttrs } from 'Helpers/Testing';

const OwnAndOweChecklistItem = ({ checklistItemResource }) => {
  const isItemComplete = checklistItemResource.isTruthy('isComplete');
  return (
    <FDStack
      direction="row"
      alignItems="center"
      spacing={1}
      {...dataAttrs(`checklist-item-${isItemComplete ? 'complete' : 'missing'}`)}
    >
      <FDIcon icon={isItemComplete ? 'check' : 'close'} color={isItemComplete ? 'success' : 'textPrimary'} size={'sm'} />
      <Richtext value={checklistItemResource.attr('name')} richtext Component={FDBodyText} />
    </FDStack>
  );
};

OwnAndOweChecklistItem.defaultProps = {};

OwnAndOweChecklistItem.propTypes = {
  checklistItemResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OwnAndOweChecklistItem };
